/* MR Mouldings — set-up fee on the PDP (snippets/setup-fee-pdp.liquid)
 *
 * Only loaded on products that owe the fee (Range includes the configured value), so every
 * variant of the product triggers it.
 * Shows what adding the current selection will cost once the set-up fee is taken into account:
 *   due      → this profile has no fee in the basket yet and the basket stays under the threshold
 *   already  → the basket already holds this profile's fee, so more lengths add nothing
 *   waived   → the basket, with this selection added, reaches the threshold
 * The cart itself is corrected by assets/mr-setup-fee.js; this only predicts it.
 */
(function () {
  'use strict';
  var cfg = window.MRSetupFee;
  var dataEl = document.querySelector('[data-mr-fee-variants]');
  var panel = document.querySelector('[data-mr-fee-panel]');
  var summary = document.querySelector('[data-mr-fee-summary]');
  if (!cfg || !dataEl || !panel || !summary) return;
  var form = summary.closest('form');
  if (!form) return;

  var data = JSON.parse(dataEl.textContent);
  var atc = form.querySelector('[data-product-atc]');
  var qtyInput = form.querySelector('[data-quantity-input]');
  var el = function (sel, root) { return (root || document).querySelector(sel); };
  var ui = {
    title: el('[data-mr-fee-title]', panel),
    text: el('[data-mr-fee-text]', panel),
    bar: el('[data-mr-fee-bar]', panel),
    fill: el('[data-mr-fee-fill]', panel),
    remaining: el('[data-mr-fee-remaining]', panel),
    basket: el('[data-mr-fee-basket]', panel),
    why: el('[data-mr-fee-why]', panel),
    itemLabel: el('[data-mr-fee-item-label]', summary),
    itemPrice: el('[data-mr-fee-item-price]', summary),
    feeNote: el('[data-mr-fee-row-note]', summary),
    feePrice: el('[data-mr-fee-row-price]', summary),
    total: el('[data-mr-fee-total]', summary)
  };
  var copy = { title: ui.title.textContent, text: ui.text.innerHTML, note: ui.feeNote.textContent };

  // The option whose values are all lengths ("2.4m"), for the "· 4.8m" total length
  var lenRe = /^(\d+(?:\.\d+)?)\s*m$/i;
  var lenIdx = -1;
  data.options.forEach(function (n, i) {
    if (lenIdx < 0 && data.variants.every(function (v) { return lenRe.test(String(v.options[i]).trim()); })) lenIdx = i;
  });
  // The line reads "2 x 2.4m Primed": every option but the profile size
  var sizeIdx = -1;
  data.options.forEach(function (n, i) { if (sizeIdx < 0 && /^size\b/i.test(String(n).trim())) sizeIdx = i; });

  function money(cents) {
    var n = cents / 100;
    var amount = n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = n.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return (cfg.moneyFormat || '£{{amount}}')
      .replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, noDec)
      .replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  var short = function (cents) { return money(cents).replace(/\.00$/, ''); };

  /* Basket state: subtotal without fee lines, and which profiles already carry a fee. */
  var basket = null;
  function readCart(cart) {
    if (!cart || !cart.items) return;
    var subtotal = cart.items_subtotal_price;
    var fees = {};
    cart.items.forEach(function (line) {
      if (line.variant_id !== cfg.variantId) return;
      subtotal -= line.final_line_price;
      if (line.properties && line.properties._setup_fee_for) fees[line.properties._setup_fee_for] = true;
    });
    basket = { subtotal: subtotal, fees: fees };
    update();
  }
  function fetchCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(readCart).catch(function () {});
  }

  function currentVariant() {
    var idField = form.querySelector('[name="id"]');
    var id = idField ? String(idField.value) : '';
    for (var i = 0; i < data.variants.length; i++) if (String(data.variants[i].id) === id) return data.variants[i];
    return null;
  }
  function quantity() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

  /* Add to cart label: Empire rewrites it on every variant change, so re-read the base each time. */
  var labelBase = null;
  var labelWritten = null;
  function labelTarget() { return atc && (atc.querySelector('.atc-button--text') || atc); }
  function setLabel(suffix) {
    var t = labelTarget();
    if (!t) return;
    if (t.textContent !== labelWritten) labelBase = t.textContent.trim();
    var next = suffix && !atc.disabled ? labelBase + ' · ' + suffix : labelBase;
    if (t.textContent !== next) t.textContent = next;
    labelWritten = t.textContent;
  }

  function update() {
    var v = currentVariant();
    var on = !!v;
    panel.hidden = !on;
    summary.hidden = !on;
    form.classList.toggle('mr-fee-active', on);
    if (!on) { setLabel(null); return; }

    var q = quantity();
    var item = v.price * q;
    var projected = (basket ? basket.subtotal : 0) + item;
    var waived = projected >= cfg.threshold;
    var already = !waived && !!(basket && basket.fees[data.handle]);
    var fee = waived || already ? 0 : cfg.price;

    // Panel
    if (waived) {
      ui.title.textContent = 'Free machine set-up';
      ui.text.innerHTML = 'Your product order is <strong>' + money(projected) + '</strong>, so there is no set-up fee.';
      ui.remaining.textContent = 'Set-up is free on this order';
    } else if (already) {
      ui.title.textContent = 'Set-up fee already in your basket';
      ui.text.innerHTML = 'More lengths of this profile do not add another fee. <strong>Free when your product order is ' + short(cfg.threshold) + ' or more.</strong>';
      ui.remaining.textContent = 'Add ' + money(cfg.threshold - projected) + ' more in products for free set-up';
    } else {
      ui.title.textContent = copy.title;
      ui.text.innerHTML = copy.text;
      ui.remaining.textContent = 'Add ' + money(cfg.threshold - projected) + ' more in products for free set-up';
    }
    panel.classList.toggle('is-waived', waived);
    var pct = Math.min(100, Math.round((projected / cfg.threshold) * 100));
    ui.fill.style.width = pct + '%';
    ui.bar.setAttribute('aria-valuenow', String(Math.min(projected, cfg.threshold) / 100));
    ui.basket.textContent = 'Products ' + money(projected) + ' / ' + short(cfg.threshold);

    // Summary
    var desc = v.options.filter(function (_, i) { return i !== sizeIdx; }).join(' ');
    var len = lenIdx >= 0 ? parseFloat(String(v.options[lenIdx])) * q : 0;
    ui.itemLabel.textContent = q + ' x ' + desc + (len ? ' · ' + (Math.round(len * 100) / 100) + 'm' : '');
    ui.itemPrice.textContent = money(item);
    ui.feeNote.textContent = waived ? 'free on this order' : already ? 'already in your basket' : copy.note;
    ui.feePrice.textContent = money(fee);
    ui.total.textContent = money(item + fee);

    setLabel(money(item + fee));
  }

  var later = function () { setTimeout(update, 0); };
  form.querySelectorAll('variant-selection').forEach(function (vs) { vs.addEventListener('variant-change', later); });
  form.addEventListener('change', later);
  if (qtyInput) qtyInput.addEventListener('input', later);
  form.addEventListener('click', function (e) { if (e.target.closest('[data-quantity-minus], [data-quantity-plus]')) later(); });
  window.addEventListener('cartcount:update', function (e) {
    if (e.detail && e.detail.items) readCart(e.detail); else fetchCart();
  });
  ui.why.addEventListener('click', function () {
    var open = ui.why.getAttribute('aria-expanded') !== 'true';
    ui.why.setAttribute('aria-expanded', String(open));
    document.getElementById(ui.why.getAttribute('aria-controls')).hidden = !open;
  });

  update();
  fetchCart();
})();
